import { matchType } from "../base/base-type";

export type GroupBatchImportResult = {
  count: number;
  validateResult: GroupBatchValidateResult;
};

export type GroupBatchValidateResult = {
  isValid: boolean;
  csvRows: GroupCsvRow[];
  errors: GroupBatchImportError[];
};

type GroupCsvRow = {
  id: string;
  name: string;
};

export type GroupBatchImportError = {
  errIdx: number;
  severity: GroupBatchImportErrorSeveritiesLiterals;
  errCode: GroupBatchImportErrorCodesLiterals;
};

const GroupBatchImportErrorSeverities = ["error", "warn"] as const;

type GroupBatchImportErrorSeveritiesLiterals =
  (typeof GroupBatchImportErrorSeverities)[number];

export const toErrorSeverityLabel = (
  severity: GroupBatchImportErrorSeveritiesLiterals,
) => {
  return matchType<GroupBatchImportErrorSeveritiesLiterals, string>(severity, {
    error: "エラー",
    warn: "警告",
  });
};

const GroupBatchImportErrorCodes = [
  "too_large_length",
  "empty_name",
  "duplicated_name_in_csv",
  "duplicated_name",
  "duplicated_id_in_csv",
  "id_not_exists",
] as const;

type GroupBatchImportErrorCodesLiterals =
  (typeof GroupBatchImportErrorCodes)[number];

export const toErrorMessage = (code: GroupBatchImportErrorCodesLiterals) => {
  return matchType<GroupBatchImportErrorCodesLiterals, string>(code, {
    too_large_length: "グループ名称は80字以内で入力してください。",
    empty_name: "グループ名称を入力してください。",
    duplicated_name_in_csv:
      "CSV内に同じグループ名称が存在します。内容を確認してください。",
    duplicated_name: "グループ名称が既に存在します。内容を確認してください。",
    duplicated_id_in_csv: "CSV内に同じグループIDが存在します。",
    id_not_exists: "グループIDが存在しません。",
  });
};
